//scss
import "./assets/scss/hope-ui.scss";
import "./assets/scss/custom.scss";
import "./assets/scss/dark.scss";
import "./assets/scss/rtl.scss";
import "./assets/scss/customizer.scss";
import "./assets/custom/css/custom.css";
// Redux Selector / Action
import { useEffect } from "react";
import { useDispatch } from "react-redux";

// import state selectors
import {
  fetchPermissionsData,
  setSetting,
  fetchRolesData,
} from "./store/setting/actions";

function App({ children }) {
  const dispatch = useDispatch();
  dispatch(setSetting());
  dispatch(fetchPermissionsData());
  dispatch(fetchRolesData());

  return <div className="App">{children}</div>;
}

export default App;
